import React from 'react'

class FlywheelHeader extends React.Component {
	render() {
		document.body.style = 'background: #fafafa'
		return <div className="fw">
			<div className="navbar">
				<div className="navbar-inner">
					<img src="/assets/flywheel-logo.svg" alt="Flywheel"/>
					<img src="/assets/powered-by-blogvault_white2.svg" alt="Powered by BlogVault"/>
				</div>
			</div>
		</div>
	}
}

export default FlywheelHeader
